export default __webpack_public_path__ + "static/knjigaOld-4584b7af599ccb43949fb45cfc02933b.png";